import axios, { type AxiosInstance } from 'axios';

import {
  ApplicationConstants,
  HttpMethod,
} from '../../../app/constants/application';
import {
  type EditPasswordInput,
  type APIStrategy,
  type PromiseOutput,
} from './api-strategy';

export class EinsteinStrategy implements APIStrategy {
  private readonly axiosClient: AxiosInstance;

  constructor(private readonly token: string | null) {
    this.axiosClient = axios.create({});
  }

  async validateToken(): Promise<PromiseOutput> {
    const response = await this.axiosClient.request({
      method: HttpMethod.GET,
      url: `${ApplicationConstants.API.ACCESS_MANAGER}/user/validate-forgot-password-token`,
      params: {
        token_forgotten_password: this.token,
      },
    });

    return response;
  }

  async editPassword(input: EditPasswordInput): Promise<PromiseOutput> {
    const response = await this.axiosClient.request({
      method: HttpMethod.PATCH,
      url: `${ApplicationConstants.API.ACCESS_MANAGER}/user/forgot-password/${input.id}`,
      params: {
        token_forgotten_password: this.token,
      },
      data: {
        nextPassword: input.password,
        nextPasswordConfirmation: input.passwordConfirmation,
      },
    });

    return response;
  }
}
